// extracted by mini-css-extract-plugin
export default {"invoiceTable":"styles_invoiceTable__FTUOh","driverInvoicePagination":"styles_driverInvoicePagination__esk1V","invoicesNotFound":"styles_invoicesNotFound__HshDw"};